import { useTranslation } from 'react-i18next';
import { PODCAST_PROVIDER_MAP, type PodcastProvider } from "shared/data/podcastProviders";

export interface PodcastProviderCardProps {
  provider: PodcastProvider;
}

export function PodcastProviderCard({ provider }: PodcastProviderCardProps) {
  const { t } = useTranslation();
  const { icon, label, href } = PODCAST_PROVIDER_MAP[provider];

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="group bg-surface-container-low p-8 rounded-2xl hover:bg-surface-bright transition-colors cursor-pointer flex flex-col items-center gap-4"
    >
      <span className="text-4xl opacity-50 group-hover:opacity-100 transition-all text-on-surface">
        {icon}
      </span>
      <span className="font-sans text-sm tracking-widest font-bold uppercase text-on-surface">
        {label}
        <span className="sr-only">{t('a11y.opensInNewTab')}</span>
      </span>
    </a>
  );
}
